import React from 'react';
const Banner = () => {
  return (   
    <section id="hero" className="hero section dark-background">    
      <div className="container">
        <div className="row gy-4">         
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"  data-aos="zoom-out" >
            <h1>Innovative IT Solutions for Your Business</h1>
            <p>
              TechBiz <span className="sitename-12">SoftwareSolutions</span> specializes in designing and developing websites, web applications, mobile applications, and custom software to drive business success.
            </p>
            <div className="d-flex">
              <a href="#about" className="btn-get-started">Get Started</a>
            </div>
          </div>     
          <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-out"  data-aos-delay="200" >
            <img src="/assets/img/hero-img.png"
             className="img-fluid animated" alt="banner" />
          </div>
        </div>
      </div>    
    </section>
  );
};

export default Banner;
